import * as MergeUtils from "@showitinc/merge-utils";
import { immutableMergeUtilsPlugin } from "@showitinc/merge-utils-immutable";

/**
 * Prepares merge util plugin selection, and re-export prepared methods along with top level package exports.
 */

const InitializedMergeUtils = MergeUtils.initialize(immutableMergeUtilsPlugin);

const {
  canPropInherit,
  expandPropsList,
  getProp,
  gatherProps,
  gatherNestedProps,
  gatherSubProps,
  getSubParent,
  hasProp,
  isPropSynced,
  inheritProp,
  isInheritedPropSynced,
  prepForInherit,
  propIsParent,
  propIsSub,
  shouldPropInherit,
  shouldPropMerge,
  shouldSyncInherit,
} = InitializedMergeUtils;

const {
  stringifyPropName,
  getDefaultSubPropParentValue,
  getSubPropsList,
  getInheritablePropName,
  gatherSubPropList,
} = MergeUtils.BaseUtils;

export {
  canPropInherit,
  expandPropsList,
  getProp,
  gatherProps,
  gatherNestedProps,
  gatherSubProps,
  getSubParent,
  hasProp,
  isPropSynced,
  inheritProp,
  isInheritedPropSynced,
  prepForInherit,
  propIsParent,
  propIsSub,
  shouldPropInherit,
  shouldPropMerge,
  shouldSyncInherit,

  stringifyPropName,
  getDefaultSubPropParentValue,
  getSubPropsList,
  getInheritablePropName,
  gatherSubPropList,
};

export default {
  ...MergeUtils,
  ...MergeUtils.BaseUtils,
  ...InitializedMergeUtils,
};
